export class CalificacionRequisitoSolicitud {
    CalificacionRequisitoSolicitudID: number;
    Calificacion: number;
    Comentarios: string;
    NomberArchivo : string;
  }